import React, { useEffect, useState } from 'react'
import CollapsibleCard from 'Components/collapsibleCard'
import DynamicTable from 'Components/dynamicTable'
import { toast } from 'react-toastify'
import Proxies from '../../components/proxies'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, Button, Input } from 'reactstrap'
import FormField from 'Components/formField'

let headers = {
  UserID: 'BrugerID',
  userName: 'Bruger Navn',
  userUID: 'UID',
  userEmail: 'Email',
  userPhone: 'Mobile',
  cprNumber: 'CPR Nr.',
  userCompany: 'Firma',
  userAddress: 'Adresse',
  userZipcode: 'Postnr.',
  userCity: 'By',
  orderCount: 'Antal ordrer',
  totalPrice: 'Skattemæssig værdi'
}

const TaxReport = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [year, setYear] = useState(new Date().getFullYear() - 1)
  const [BrandID, setBrandID] = useState(null)
  const [brands, setBrands] = useState([])
  const [emails, setEmails] = useState(null)

  function fetchOrderTaxReport() {
    Proxies.GET('orders/getTaxOrders', { year, BrandID }).then(response => {
      if (response) {
        setData(response)
      }
    })
  }

  function sendTaxReport() {
    if (!emails) return
    Proxies.POST('orders/sendTaxReport', { year, BrandID, emails }).then(response => {
      if (response) {
        toast.success('Email sent successfully', {
          autoClose: 5000
        })
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    Proxies.GET('menus/listBrands').then(responseJSON => {
      setBrands(responseJSON)
    })
    setLoading(false)
  }, [])

  if (loading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }

  return (
    <React.Fragment>
      <CollapsibleCard header={<strong>Ordrer</strong>} startOpen={true}>
        <Form
          onSubmit={e => {
            e.preventDefault()
          }}
        >
          <FormField field={'BrandID'} name='Brand'>
            <Input
              type='select'
              name='BrandID'
              value={BrandID}
              onChange={e => {
                setBrandID(e.target.value)
              }}
            >
              <option selected='true' disabled={true} value={''}>
                Select Brand
              </option>
              {brands &&
                !!brands.length &&
                brands.map(e => {
                  return (
                    <option value={e.BrandID} key={e.BrandID}>
                      {e.BrandID} - {e.brandName}
                    </option>
                  )
                })}
            </Input>
          </FormField>
          <FormField name='Year' rows={5} field='year'>
            <Input type='number' onChange={e => setYear(e.target.value)} name='year' value={year} />
          </FormField>
          {data?.length ? (
            <FormField name='Emails' rows={5} field='emails'>
              <Input
                type='email'
                onChange={e => setEmails(e.target.value)}
                name='emails'
                value={emails}
                placeholder='Enter email addresses, use ; to specify mulitple'
              />
            </FormField>
          ) : null}
        </Form>
        <div style={{ flexDirection: 'row', marginBottom: 32, paddingHorizontal: 16 }}>
          <Button disabled={!year || !BrandID} style={{ marginRight: 16 }} onClick={() => fetchOrderTaxReport()}>
            Search
          </Button>
          <Button disabled={!data?.length || !emails?.length} style={{ marginLeft: 16 }} onClick={() => sendTaxReport()}>
            Send Report
          </Button>
        </div>
        {data && !data.length ? <p>No Orders in the selected year.</p> : null}
        {data?.length ? <DynamicTable data={data} headers={headers} /> : null}
      </CollapsibleCard>
    </React.Fragment>
  )
}

export default TaxReport
